import { createContext } from 'react';

export interface PreviewProfileValue {
  readonly displayName: string;
  readonly setDisplayName: (name: string) => void;
}

// In-memory presentation state only. Never persisted or sent to an auth/provider API.
export const PreviewProfileContext = createContext<PreviewProfileValue | null>(null);
